/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.filter('RangeFilterEvent', function () {
    return function (input, total, arbeiter) {
        total = parseInt(total);
        var emails = []
        for (var i = 0; i < total; i++) {
            var email = Object.keys(arbeiter)[i]
            
            if(email == undefined)
            {
                input.push(i);
            }
            else
            {
                input.push(email);
                
            }
        }
        
        if(total == -1)
        {
            input.push(-1)
            Object.keys(arbeiter).forEach(function(email){
                input.push(email)
            })
        }
        return input;
    };
});